import { Component, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ListOption } from '../../../../modules/tcm-core.module';
import { FormControlBase } from '../../../../modules/tcm-form/common/form-control-base/form-control-base';

@Component({
    selector: 'radio-buttons-input',
    templateUrl: './radio-buttons-input.component.html',
    styleUrls: ['./radio-buttons-input.component.scss'],
    inputs: ['label', 'disabled', 'hideValidationMessages', 'isReadonlyValue', 'placeholder', 'tabindex'],
    standalone: false
})
export class RadioButtonsInputComponent extends FormControlBase<number | string> {

  constructor(@Self() @Optional() protected override ngModel: NgControl) {
    super('radio-buttons-input', ngModel);
  }

  @Input() options: ListOption<number | string>[] = [];

  // @Input() isReadonlyValue: boolean;

  selectedOption: ListOption<number | string>;

  override onValueWritten(previousValue: number | string, newValue: number | string) {
    super.onValueWritten(previousValue, newValue);
    if (!newValue) {
      this.selectedOption = null;
    }
    else if (!this.options || !this.options.length) {
      this.selectedOption = {
        value: newValue,
        displayName: 'NO OPTIONS PROVIDED'
      };
    }
    else {
      const selectedOption = this.options.find(x => x.value == newValue);

      this.selectedOption = selectedOption || {
        value: newValue,
        displayName: 'NO OPTIONS PROVIDED'
      } as any;
    }
  }
}
